// src/app/services/admin-visitors.service.ts

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
      ActiveVisitorsNow,
      ApiResponse,
      RecentVisitor,
      TopVisitorPath,
      VisitorNavigationTrace,
      VisitorSummary,
      VisitorTimelineItem,
    } from 'app/models/admin-visitors.model';

    
import { environment } from 'environments/environment';





export interface VisitorDateRangeQuery {
  from?: string;
  to?: string;
  limit?: number;
  minutes?: number;
}

export interface VisitorNavigationTraceQuery {
  visitorId?: string;
  visitorKey?: string;
  from?: string;
  to?: string;
  limit?: number;
  sessionTimeoutMinutes?: number;
}

@Injectable({
  providedIn: 'root',
})
export class AdminVisitorsService {
  private readonly baseUrl = `${environment.apiBaseUrl}/admin-visitors`;

  constructor(private http: HttpClient) {}

  getSummary(
    query: VisitorDateRangeQuery = {}
  ): Observable<ApiResponse<VisitorSummary>> {
    return this.http.get<ApiResponse<VisitorSummary>>(`${this.baseUrl}/summary`, {
      params: this.buildParams(query),
    });
  }

  getTimeline(
    query: VisitorDateRangeQuery = {}
  ): Observable<ApiResponse<VisitorTimelineItem[]>> {
    return this.http.get<ApiResponse<VisitorTimelineItem[]>>(
      `${this.baseUrl}/timeline`,
      {
        params: this.buildParams(query),
      }
    );
  }

  getRecent(
    query: VisitorDateRangeQuery = {}
  ): Observable<ApiResponse<RecentVisitor[]>> {
    return this.http.get<ApiResponse<RecentVisitor[]>>(`${this.baseUrl}/recent`, {
      params: this.buildParams(query),
    });
  }

  getTopPaths(
    query: VisitorDateRangeQuery = {}
  ): Observable<ApiResponse<TopVisitorPath[]>> {
    return this.http.get<ApiResponse<TopVisitorPath[]>>(
      `${this.baseUrl}/top-paths`,
      {
        params: this.buildParams(query),
      }
    );
  }

  getActiveNow(
    query: VisitorDateRangeQuery = {}
  ): Observable<ApiResponse<ActiveVisitorsNow>> {
    return this.http.get<ApiResponse<ActiveVisitorsNow>>(
      `${this.baseUrl}/active-now`,
      {
        params: this.buildParams(query),
      }
    );
  }

  getVisitorNavigationTrace(
    query: VisitorNavigationTraceQuery = {}
  ): Observable<ApiResponse<VisitorNavigationTrace>> {
    return this.http.get<ApiResponse<VisitorNavigationTrace>>(
      `${this.baseUrl}/navigation`,
      {
        params: this.buildParams(query),
      }
    );
  }

  searchVisitorsByPagePath(params: {
  path: string;
  from?: string;
  to?: string;
  limit?: number;
  }) {
    return this.http.get<any>(`${this.baseUrl}/page-search`, {
      params: {
        path: params.path,
        from: params.from || '',
        to: params.to || '',
        limit: String(params.limit || 100),
      },
    });
  }

  // src/app/services/admin-visitors.service.ts

getBehaviorInsights(params: {
  from?: string;
  to?: string;
  sessionTimeoutMinutes?: number;
  maxTimeOnPageSeconds?: number;
}) {
  return this.http.get<any>(`${this.baseUrl}/behavior-insights`, {
    params: {
      from: params.from || '',
      to: params.to || '',
      sessionTimeoutMinutes: String(params.sessionTimeoutMinutes || 30),
      maxTimeOnPageSeconds: String(params.maxTimeOnPageSeconds || 1800),
    },
  });
}

  private buildParams(
    query: VisitorDateRangeQuery | VisitorNavigationTraceQuery
  ): HttpParams {
    let params = new HttpParams();

    Object.entries(query).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.set(key, String(value));
      }
    });

    return params;
  }
}